// This is just an example,
// so you can safely delete all default props below

export default {
    title: 'Konto vellykket slettet',
    description: 'Din konto er nå slettet. Gyldige billetter er fortsatt gyldige. Du er velkommen til å opprette en ny konto igjen.'
}
